import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { BlocksRenderer } from "@strapi/blocks-react-renderer"
import { Cta } from "../libs/helpers"

import * as styles from "./hero.module.scss"

const Hero = ({ title, heroData }) => {
  const {
    background,
    bonus,
    ctas,
    description,
    theme,
  } = heroData
  const backgroundImg = background ? getImage(background.localFile) : undefined
  const bonusImg = bonus ? getImage(bonus.localFile) : undefined

  // analytics issue
  // easier than having a conversation
  useEffect(() => {
    if (theme === 'home') {
      document.querySelector('[href="/military-medicine-101"]').setAttribute('class', 'red--btn')
      document.querySelector('[href="/applying-and-what-to-expect"]').setAttribute('class', 'white--btn')
    }
  })

  return (
    <section className={styles[theme]}>
      <div className={styles['image']}>
        <div className={styles['content']}>
          <h1>{title}</h1>
          { bonusImg &&
          <div className={styles['bonus']}>
            <GatsbyImage image={bonusImg} alt={bonus.alternativeText || 'alt'} />
          </div>
          }
          { description && theme === 'home' &&
          <div className={styles['description']}>
            <BlocksRenderer content={description} />
          </div>
          }
          { ctas && ctas.length > 0 && 
          <div className={styles['ctas']}>
            {ctas.map((cta, i) => <Cta key={i} cta={{page:cta}}/>)}
          </div>
          }
        </div>
        { backgroundImg &&
          <GatsbyImage image={backgroundImg} alt={background.alternativeText || 'alt'} className={styles['backgroundImg']} />
        }
      </div>
      { description && theme !== 'home' &&
      <div className={styles['description']}>
        { bonusImg &&
        <span className={styles['bonusBox']}></span>
        }
        <BlocksRenderer content={description} />
      </div>
      }
    </section>
  )
}

export default Hero

export const query = graphql`
  fragment HeroData on STRAPI__COMPONENT_COMPONENT_HERO {
    theme
    background {
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
    bonus {
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(width: 100 placeholder: BLURRED)
        }
      }
    }
    description {
      children {
        children {
          children {
            text
            type
          }
          text
          type
          url
        }
        text
        type
        url
      }
      format
      type
    }
    ctas {
      title
      path
    }
  }
`
